import { ClipboardList, FileText, UserCheck, LogOut, RotateCcw, Activity, Layers3, Target, Calendar, BarChart3, HeartHandshake, Brain, MapPin, Zap, MessageCircle, Users, Star, MonitorSpeaker, Award, Building, Coins, Crown, Flame, Gauge, GraduationCap, Lightbulb, Megaphone, Scale, ShieldCheck, Smile, SunMoon, MessageSquare } from "lucide-react";

export const iconMap: Record<string, any> = {
  ClipboardList,
  FileText,
  UserCheck,
  LogOut,
  RotateCcw,
  Activity,
  Layers3,
  Target,
  Calendar,
  BarChart3,
  HeartHandshake,
  Brain,
  MapPin,
  Zap,
  MessageCircle,
  Users,
  Star,
  MonitorSpeaker,
  Award,
  Building,
  Coins,
  Crown,
  Flame,
  Gauge,
  GraduationCap,
  Lightbulb,
  Megaphone,
  Scale,
  ShieldCheck,
  Smile,
  SunMoon,
  MessageSquare
};

export function getIconComponent(iconName?: string) {
  return (iconName && iconMap[iconName]) || ClipboardList;
} 